module.exports = __webpack_public_path__ + "static/manuela-francke-logo-1e94d610766c2999ac92e6b4dada2b30.svg";